import { useState } from "react";
import { Box, Button, Image, Text, useDisclosure } from "@chakra-ui/react";
import { HasAccess } from "../../../../common/utils/accessUtils";
import CommonCheckTable from "common/components/checktable";
import { SearchIcon } from "@chakra-ui/icons";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDeleteModel from "common/components/commonDeleteModel";
import { toast } from "react-toastify";
import viewIcon from "common/assets/img/viewIcon.png";
import editIcon from "common/assets/img/editIcon.png";
import { globalStyles } from "common/theme/styles";
import { campgainData } from "services/Recruit/data/campgain";
import { constant } from "common/constant";
import deleteIcon from "common/assets/img/deleteIcon.png";
import { recruitConstant } from "services/Recruit/constant";
import CustomStatusDropdown from "services/Recruit/components/AvailabilityDropdown";
import { customDropDownData } from "services/Recruit/data/recruitData";

const Campgain = () => {
  const title = recruitConstant.createCampaigns;
  const [action, setAction] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [edit, setEdit] = useState(false);
  const [eventView, setEventView] = useState(false);
  const [id, setId] = useState("");
  const [selectedId, setSelectedId] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
  const [searchboxOutside, setSearchboxOutside] = useState("");
  const [deleteMany, setDeleteMany] = useState(false);
  const [isImportLead, setIsImportLead] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const colors = globalStyles.colors;
  const [tableData, setTableData] = useState(campgainData);
  const [permission, leadAccess, contactAccess] = HasAccess([
    "Tasks",
    "Leads",
    "Contacts",
  ]);
  const navigate = useNavigate();

  const location = useLocation();
  const state = location.state;

  const actionHeader = {
    Header: recruitConstant.actions,
    isSortable: false,
    center: true,
    cell: ({ row }) => (
      <Text fontSize="md" fontWeight="900" textAlign={"center"}>
        <Box className="actionCellContainer">
          {/* {permission?.view && (
            <Image
              onClick={() =>
                navigate(`/recruit/campaignCreate/${row?.values?.id}`)
              }
              src={viewIcon}
              h={"20px"}
              w={"20px"}
            />
          )} */}
          {permission?.update && (
            <Image
              onClick={() =>
                navigate(`/recruit/campaignCreate/${row?.values?.id}`)
              }
              src={editIcon}
              h={"20px"}
              w={"20px"}
            />
          )}
          {permission?.delete && (
              <Image
                onClick={() => {
                  setDeleteMany(true);
                  setSelectedValues([row?.values?.id]);
                }}
                src={deleteIcon}
                h={"20px"}
                w={"20px"}
              />
          )}
        </Box>
      </Text>
    ),
  };
  const tableColumns = [
    {
      Header: "#",
      accessor: "id",
      isSortable: false,
      width: 5,
    },
    {
      Header: recruitConstant.campaignOwner,
      accessor: "campaignOwner",
    },
    {
      Header: recruitConstant.type,
      accessor: "type",
    },

    {
      Header: recruitConstant.campaignName,
      accessor: "wb4you",
    },
    {
      Header: recruitConstant.status,
      accessor: "status",
      type: "text",
      cell: (cell) => (
        <div>
           <CustomStatusDropdown
            statusOptions={customDropDownData}
            defaultStatus={recruitConstant.completed} 
          />

        </div>
      ),
    },
    {
      Header: recruitConstant.date,
      accessor: "date",
    },
    {
      Header: recruitConstant.expectedRevenue,
      accessor: "expectedRevenue",
    },
    {
      Header: recruitConstant.budgetCost,
      accessor: "budgetCost",
    },
    {
      Header: recruitConstant.actualCost,
      accessor: "actualCost",
    },
    {
      Header: recruitConstant.numberSent,
      accessor: "numberSent",
    },

    ...(permission?.update || permission?.view || permission?.delete
      ? [actionHeader]
      : []),
  ];

  const handleDeleteProfile = async (ids) => {
    const updatedData = tableData.filter((item) => !ids.includes(item.id));
    setTableData(updatedData);
    setSelectedValues([]);
    setDeleteMany(false);
    toast.success(recruitConstant.deleteMsg);
  };

  const [columns, setColumns] = useState([...tableColumns]);
  const [selectedColumns, setSelectedColumns] = useState([...tableColumns]);

  const dataColumn = tableColumns.filter((item) =>
    selectedColumns.some((column) => column.Header === item.Header)
  );

  return (
    <div>
      <CommonCheckTable
        title={title}
        isLoading={isLoading}
        columnData={columns}
        dataColumn={dataColumn}
        allData={tableData}
        tableData={tableData}
        searchDisplay={displaySearchData}
        setSearchDisplay={setDisplaySearchData}
        searchedDataOut={searchedData}
        setSearchedDataOut={setSearchedData}
        tableCustomFields={[]}
        access={permission}
        action={action}
        setAction={setAction}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        isOpen={isOpen}
        onClose={onclose}
        state={state}
        onOpen={onOpen}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setDelete={setDeleteMany}
        AdvanceSearch={
          <Button
            variant="outline"
            className="advance-search-button"
            colorScheme="brand"
            leftIcon={<SearchIcon />}
            mt={{ sm: "5px", md: "0" }}
            size="sm"
            onClick={() => setAdvanceSearch(true)}
          >
            {recruitConstant.advanceSearch}
          </Button>
        }
        getTagValuesOutSide={getTagValuesOutSide}
        searchboxOutside={searchboxOutside}
        setGetTagValuesOutside={setGetTagValuesOutside}
        setSearchboxOutside={setSearchboxOutside}
      />



      <CommonDeleteModel
        isOpen={deleteMany}
        onClose={() => setDeleteMany(false)}
        type={recruitConstant.campgain}
        handleDeleteData={handleDeleteProfile}
        ids={selectedValues}
      />
    </div>
  );
};

export default Campgain;
